import { Outlet, useNavigate } from "react-router-dom";
import styles from "./AdminLayout.module.css";

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/admin-login");
  };

  return (
    <div className={styles.adminLayout}>
      <header className={styles.adminHeader}>
        <h2>Panel de Administración</h2>

        <button
          className={styles.logoutButton}
          onClick={handleLogout}
        >
          Salir
        </button>
      </header>

      <main className={styles.adminContent}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
